import { Component, EventEmitter, Inject, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalRef, SidePanel } from '@anthem/uxd/modal';
import { ICareProvider } from '../../../../care-circle/interfaces/iCareProvider';
import { AppExternalCommands } from '../../../../common/constants/app-constants';
import { AppNavigations } from '../../../../common/constants/app-navigations';
import { AppEvents } from '../../../../common/enums/appEvents';
import { IEventDetail } from '../../../../common/interfaces/iEventDetail';
import { ClinicalProgramNavigator } from '../../../../common/services/clinicalProgramNav';
import { EventHandler } from '../../../../common/services/eventHandler';
import { NavigationService } from '../../../../common/services/navigationService';
import { AppSession } from '../../../../common/values/appSession';
import { BaseComponent } from '../../../common/components/core/baseCmp';
import { PROVIDER_TYPE } from '../../../common/constants/common';

@Component({
  moduleId: module.id,
  selector: 'app-fc-health-sys-founder-info-cmp',
  templateUrl: './healthSysFounderInfoCmp.html'
})
export class HealthSysFounderInfoComponent extends BaseComponent {
  founderInfo: ICareProvider;
  careTeamContent = this.content?.careCircle;
  providerTypes = PROVIDER_TYPE;
  founderInfoPanelRef: ModalRef<HTMLElement>;
  @ViewChild('founderInfoPanel') founderInfoPanel: TemplateRef<HTMLElement>;

  constructor(
    @Inject(AppSession)
    private _appSession: AppSession,
    private _route: ActivatedRoute,
    private _eventHandler: EventHandler,
    private _sidePanel: SidePanel,
    private _clinicalProgramNav: ClinicalProgramNavigator,
    private _navigationService: NavigationService
  ) {
    super(_route, _eventHandler, _appSession);
  }

  /**
   * Method to open side panel
   */
  openSidePanel(careProvider: ICareProvider) {
    this.founderInfo = careProvider;
    this.founderInfoPanelRef = this._sidePanel.open('right', this.founderInfoPanel);
  }

  /**
   * Close the founder info side panel
   */
  onClose() {
    this.founderInfoPanelRef.close();
    this.founderInfo = null;
  }

  /**
   * Method to emit open contact-us event to the parent application
   */
  onContactUsClick() {
    this.onClose();
    const appCmdEvt: EventEmitter<IEventDetail> = this._eventHandler.get(AppEvents[AppEvents.PF_APP_COMMAND]);
    const eventDetail = {} as IEventDetail;
    eventDetail.type = AppEvents[AppEvents.PF_APP_CMD_NAV];
    eventDetail.message = AppExternalCommands.RCP_CONTACT_US.MSG;
    eventDetail.target = AppExternalCommands.RCP_CONTACT_US.CMD;
    appCmdEvt.emit(eventDetail);
  }

  /**
   * Method to navigate to the clinical program
   * @param programId - Program ID
   */
  navigateToProgram(programId: string) {
    this.onClose();
    this._clinicalProgramNav.navigateToClinicalProgram(programId);
  }

  /**
   * Method to navigate to the search page with the selected provider type code
   */
  searchByProviderCode(providerTypeCode: PROVIDER_TYPE) {
    this.onClose();
    this._appSession.searchParams.typeSelectNm = providerTypeCode;
    this._appSession.searchParams.providerTypeCodeList = [providerTypeCode];
    this._appSession.searchParams.selectedTypeCodes = [providerTypeCode];
    this._navigationService.navigateByUrl(AppNavigations.FCR_RESULT_PATH);
  }
}
